import { ChakraButton, ChakraModalCloseButton } from "@airhelp/react-ui-components";
import { useModal } from "contexts/ModalContext";
import { renderDynamicComponent } from "modules/storyblok/DynamicComponent";
import type { SbEditableComponentProps } from "types/storyblok";
import type { ModalProps } from "./Modal.d";

export const Modal = ({
  content,
  buttonText,
  buttonSize,
  buttonVariant,
  modalSize,
  sbEditable,
}: SbEditableComponentProps<ModalProps>) => {
  const { openModal } = useModal();

  const modalContent = (
    <>
      <ChakraModalCloseButton />
      {renderDynamicComponent(content)}
    </>
  );

  const handleOnClick = () => openModal(modalContent, modalSize);

  return (
    <ChakraButton size={buttonSize} variant={buttonVariant} onClick={handleOnClick} {...sbEditable}>
      {buttonText}
    </ChakraButton>
  );
};
